"use client";

import { useContext, useEffect, useState } from "react";

import { analyticsContext } from "../lib";
import { type AnalyticsEvent, HallowAnalyticsEvent } from "../types";

export type UseViewedScreenProps = Partial<AnalyticsEvent>;

export const useViewedScreen = ({ ...props }: UseViewedScreenProps) => {
  const [isMounted, setIsMounted] = useState(false);
  const { track } = useContext(analyticsContext);

  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);

  useEffect(() => {
    if (isMounted)
      track({
        event: HallowAnalyticsEvent.ViewedScreen,
        ...props,
      });
  }, [isMounted, JSON.stringify(props)]);
};
